import React from 'react';
import { Code, Apple, Android, Web, Storage, Functions } from '@mui/icons-material';

const LanguageTabs = ({ activeLanguage, onLanguageChange }) => {
    const languages = [
        {
            id: 'javascript',
            name: 'Node.js',
            icon: Web, // Icône alternative
            description: 'JavaScript/TypeScript'
        },
        {
            id: 'python',
            name: 'Python',
            icon: Functions, // Icône alternative
            description: 'Python 3.7+'
        },
        {
            id: 'php',
            name: 'PHP',
            icon: Storage, // Icône alternative
            description: 'PHP 7.4+'
        },
        {
            id: 'rest',
            name: 'REST API',
            icon: Code,
            description: 'Direct API calls'
        },
        {
            id: 'ios',
            name: 'iOS',
            icon: Apple,
            description: 'Swift/Objective-C'
        },
        {
            id: 'android',
            name: 'Android',
            icon: Android,
            description: 'Kotlin/Java'
        }
    ];

    return (
        <div className="bg-white rounded-2xl shadow-lg border border-amber-100/50 p-6">
            <h3 className="text-xl font-bold text-gray-900 mb-4">Choisissez votre langage</h3>
            <p className="text-gray-600 mb-6">Sélectionnez votre environnement de développement</p>

            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
                {languages.map((language) => {
                    const IconComponent = language.icon;
                    const isActive = activeLanguage === language.id;

                    return (
                        <button
                            key={language.id}
                            onClick={() => onLanguageChange(language.id)}
                            className={`p-4 rounded-xl border-2 transition-all duration-300 group ${
                                isActive
                                    ? 'border-amber-500 bg-gradient-to-r from-amber-50 to-yellow-50 text-amber-700 shadow-md'
                                    : 'border-gray-200 text-gray-600 hover:border-amber-300 hover:bg-amber-50/30'
                            }`}
                        >
                            <div className="text-center">
                                <IconComponent className={`text-2xl mx-auto mb-2 transition-transform group-hover:scale-110 ${
                                    isActive ? 'text-amber-600 scale-110' : 'text-gray-500'
                                }`} />
                                <div className={`font-semibold text-sm mb-1 ${
                                    isActive ? 'text-amber-700' : 'text-gray-700'
                                }`}>
                                    {language.name}
                                </div>
                                <div className={`text-xs ${
                                    isActive ? 'text-amber-600' : 'text-gray-500'
                                }`}>
                                    {language.description}
                                </div>
                            </div>
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default LanguageTabs;